import * as React from 'react';
import { Grid, Image, List, Icon, Table } from 'semantic-ui-react';

import Loader from './Loader';

import formats from '../helpers/formats';

import resultadosService from '../services/resultados.service';

class Resultados extends React.Component {
    constructor(props) {
        super(props);

        try {
            const localState = localStorage.getItem('state');

            if (localState) {
                const state = JSON.parse(localState);
                localStorage.removeItem('state');
                this.state = { ...state };
            } else {
                this.state = {
                    isLoading: false,
                    dataSelecionada: undefined,
                    registros: [],
                    resultados: []
                };
            }
        } catch (e) {
            this.state = {
                isLoading: false,
                dataSelecionada: undefined,
                registros: [],
                resultados: []
            };
        }
    }

    async componentDidMount() {
        try {

            if (this.state.resultados.length === 0) {

                this.setState({ isLoading: true });

                const { data: registros } = await resultadosService.getRegistros();

                this.setState({ registros });

                this.onChangeDate(registros[0].ano);
            }
        }
        catch (err) {
            console.log(err);
            this.props.history.push('/');
        }
    }

    onChangeDate = async (value) => {
        this.setState({ dataSelecionada: value, isLoading: true });

        try {

            const { data: resultados } = await resultadosService.getResultados({ ano: value });

            this.setState({ isLoading: false, resultados }, () => localStorage.setItem('state', JSON.stringify(this.state)))
        }
        catch (err) {
            console.log(err);
            this.props.history.push('/');
        }
    }

    onPressAtendimento = async (atendimento) => {
        if (atendimento.disponivel) {

            this.setState({ ...this.state, isLoading: true });

            try {
                await resultadosService.getLaudo(atendimento);
            } catch (error) {
                console.log(error);
            }

            this.setState({ ...this.state, isLoading: false });
        }
    }

    render() {

        const verificado = require('../img/verificado-sm.png');
        const andamento = require('../img/andamento-sm.png');
        const parcial = require('../img/parcial-sm.png');

        return (<Grid >
            <Loader isLoading={this.state.isLoading} />
            <Grid.Column width={4} >
                <List className='listaFiltro'>
                    <List.Item>
                        <List.Icon name={this.state.dataSelecionada ? 'folder' : 'folder open'} />
                        <List.Content>
                            <List.Header>Todos os exames</List.Header>
                            <List.List>
                                {this.state.registros.map((item, index) =>
                                    <List.Item key={index} onClick={() => this.onChangeDate(item.ano)}>
                                        <List.Icon name={this.state.dataSelecionada !== item.ano ? 'folder' : 'folder open'} />
                                        <List.Content>
                                            <List.Header>{item.ano} ({item.quantidade})</List.Header>
                                        </List.Content>
                                    </List.Item>
                                )}
                            </List.List>
                        </List.Content>
                    </List.Item>
                </List>
            </Grid.Column>
            <Grid.Column width={12} >
                <div className='listaExamesMedico'>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={5}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={1}>
                                            <Image src={verificado} className="imgLegendaLaudos" />
                                        </Grid.Column>
                                        <Grid.Column width={13}>
                                            <label className="lblLegendaLaudos">Resultados Prontos</label>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={1}>
                                            <Image src={parcial} className="imgLegendaLaudos" />
                                        </Grid.Column>
                                        <Grid.Column width={13}>
                                            <label className="lblLegendaLaudos">Resultados Parciais</label>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width={5
                            }>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={1}>
                                            <Image src={andamento} className="imgLegendaLaudos" />
                                        </Grid.Column>
                                        <Grid.Column width={13}>
                                            <label className="lblLegendaLaudos">Em Andamento</label>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Table celled striped >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Talão</Table.HeaderCell>
                                <Table.HeaderCell>Data</Table.HeaderCell>
                                <Table.HeaderCell colSpan='2'>Nome do Paciente</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.state.resultados.map((item, index) =>
                                <Table.Row key={index} onClick={() => this.onPressAtendimento(item)}>
                                    <Table.Cell collapsing>
                                        <Icon name='file outline' />{item.ateCod}
                                    </Table.Cell>
                                    <Table.Cell collapsing>{formats.toDate(item.ateData)}</Table.Cell>
                                    <Table.Cell>{item.pacNome}</Table.Cell>
                                    <Table.Cell textAlign='right'>
                                        <Image.Group>
                                            <Image src={item.disponivel ? (item.possuiLaudoPendente ? parcial : verificado) : andamento} />
                                            {item.disponivel ? (<Image src={require('../img/icon-pdf-sm.png')} />) : null}
                                        </Image.Group>
                                    </Table.Cell>
                                </Table.Row>
                            )}
                        </Table.Body>
                    </Table>
                </div>
            </Grid.Column >
        </Grid >);
    }
}

export default Resultados;